import { Module } from 'vuex';
import { AbsenceTypeState, RootState } from '@/general/store/states';
import { CacheConfig } from '@/shared/constants/CacheConfig';
import AbsenceTypeClient from '../client/AbsenceTypeClient';
import AbsenceType  from '../models/AbsenceType';

let listExpireTime = 0;

const module: Module<AbsenceTypeState, RootState> = {
  namespaced: true,

  state: {
    list: [],
  },

  mutations: {
    setList(state, absenceTypes: Array<AbsenceType>) {
      state.list = absenceTypes;
    },

    clear(state) {
      state.list = [];
    },
  },

  getters: {
    activeTypes(state): Array<AbsenceType> {
      return state.list.filter(t => t.isActive);
    },
  },

  actions: {
    async loadAll({ commit }) {
      const now = Date.now();
      if (now < listExpireTime) return;
      const absenceTypes = await AbsenceTypeClient.loadAll();
      commit('setList', absenceTypes);
      listExpireTime = now + CacheConfig.DEFAULT_TTL;
    },
  },
};

export default module;
